// Static data for the About page
import { FiShield, FiGlobe, FiHeart, FiTarget, FiAward, FiUsers, FiClock } from 'react-icons/fi';

export const ABOUT_CONTENT = {
  eyebrow: 'About Us',
  heading: 'Unforgettable Vietnam',
  intro:
    'OrbisDMC crafts effortless, authentic Vietnam journeys for partners and global travellers.',
  mission:
    'Our mission is to unlock the very best of Vietnam through deep local knowledge, trusted relationships, and a relentless commitment to quality. We design journeys that flow seamlessly from arrival to departure, with every detail anticipated before it is asked for.',
  vision:
    'We envision a world where Vietnam is not just a destination on a map, but a memory that lingers — through its flavours, landscapes, and the warmth of its people.',
};

export const ABOUT_VALUES = [
  {
    id: 'integrity',
    icon: FiShield,
    title: 'Integrity',
    description:
      'We honour commitments with absolute reliability. Every quoted price, promised upgrade, and confirmed itinerary is delivered as agreed — no surprises.',
  },
  {
    id: 'craft',
    icon: FiGlobe,
    title: 'Local Mastery',
    description:
      'Our team lives and breathes Vietnam. We do not outsource — we personally design, coordinate, and oversee every experience with on-ground expertise.',
  },
  {
    id: 'care',
    icon: FiHeart,
    title: 'Personal Care',
    description:
      'You are never a number. Every partner and traveller receives dedicated support before, during, and after their journey — because relationships matter more than transactions.',
  },
  {
    id: 'excellence',
    icon: FiTarget,
    title: 'Precision',
    description:
      'From private airport transfers to complex MICE itineraries, we operate with surgical precision. Logistics are invisible when they work perfectly — and we ensure they always do.',
  },
];

export const ABOUT_STORY = {
  eyebrow: 'Our Story',
  heading: 'Vietnam, Designed by Experts',
  paragraphs: [
    'At Orbis, we create seamless travel experiences that inspire connections, support business growth, and deliver lasting memories.',
    'Specializing in Corporate Travel, MICE, Destination Weddings, Destination Management, and B2B Travel Solutions, we combine expertise, precision, and reliability to deliver exceptional journeys worldwide.',
  ],
  image: 'https://images.unsplash.com/photo-1774248833635-1e0aa8c7c864?q=80&w=1200&auto=format&fit=crop',
  imageAlt: 'Large bronze Buddha statue atop a hill',
};

export const ABOUT_STATS = [
  { id: 'years', value: 10, suffix: '+', label: 'Years of Experience', icon: FiAward },
  { id: 'travellers', value: 5000, suffix: '+', label: 'Happy Travelers', icon: FiHeart },
  { id: 'partners', value: 100, suffix: '+', label: 'Trusted Partners', icon: FiUsers },
  { id: 'support', value: 24, suffix: '/7', label: 'Support', icon: FiClock },
];

export const TEAM_LEADERSHIP = [
  {
    id: 1,
    name: 'Minh Nguyen',
    role: 'Founder & CEO',
    bio: 'With over 20 years in luxury travel and hospitality across Southeast Asia, Minh founded OrbisDMC with a vision to showcase Vietnam through the lens of authentic, high-touch experiences. A former general manager at Belmond, he brings world-class operational rigour to every itinerary.',
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?q=80&w=600&auto=format&fit=crop',
    linkedin: '#',
  },
  {
    id: 2,
    name: 'Linh Tran',
    role: 'Director of Operations',
    bio: 'Linh oversees every on-ground detail with surgical precision. Her decade of experience in MICE and high-end leisure means nothing is left to chance. She has orchestrated programs for Fortune 500 clients, luxury travel advisors, and royal households.',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=600&auto=format&fit=crop',
    linkedin: '#',
  },
  {
    id: 3,
    name: 'Hieu Pham',
    role: 'Head of Partnerships',
    bio: 'Hieu curates our network of 100+ trusted suppliers across Vietnam, Laos, and Cambodia. From five-star resorts to private chefs and heritage artisans, he ensures every partner meets the exacting standards our clients expect.',
    image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?q=80&w=600&auto=format&fit=crop',
    linkedin: '#',
  },
  {
    id: 4,
    name: 'Anh Dao',
    role: 'Creative Director',
    bio: 'Anh designs the immersive journeys that set Orbisapart. A former travel editor and photographer, she weaves storytelling, local culture, and design thinking into every program — from intimate culinary tours to grand celebratory events.',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=600&auto=format&fit=crop',
    linkedin: '#',
  },
];

export const TEAM_CORE = [
  { id: 1, name: 'Tuan Le', role: 'Senior Travel Designer', image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=300&auto=format&fit=crop' },
  { id: 2, name: 'Mai Hoang', role: 'Client Relations Manager', image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=300&auto=format&fit=crop' },
  { id: 3, name: 'Duc Vo', role: 'MICE Coordinator', image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=300&auto=format&fit=crop' },
  { id: 4, name: 'Thao Nguyen', role: 'Destination Specialist', image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=300&auto=format&fit=crop' },
  { id: 5, name: 'Bao Tran', role: 'Logistics Lead', image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?q=80&w=300&auto=format&fit=crop' },
  { id: 6, name: 'Lan Vu', role: 'Wedding & Events Planner', image: 'https://images.unsplash.com/photo-1558898479-33c0057a5d12?q=80&w=300&auto=format&fit=crop' },
];
